import { Connector } from "../../types";

export const ConnectorCard: React.FC<{
  connector: Connector;
  onConfigure: (id: string) => void;
  isSelected?: boolean;
  onSelect?: (connector: Connector) => void;
  onShowGuide?: (connector: Connector) => void;
}> = ({
  connector,
  isSelected = false,
  onSelect,
  onShowGuide,
}) => {
  const handleCardClick = () => {
    onSelect?.(connector);
    onShowGuide?.(connector);
  };
  return (
    <div
      className={`bg-white border hover:shadow-md cursor-pointer p-6 rounded-lg ${
        isSelected
          ? "border-blue-500 ring-2 ring-blue-500 ring-opacity-50"
          : "border-gray-200"
      }`}
      onClick={handleCardClick}
    >
      <div className="flex justify-between items-start mb-4">
        <div className="flex items-center">
          {connector.icon && (
            <span className="text-2xl mr-3">{connector.icon}</span>
          )}
          <h3 className="text-lg font-medium text-gray-900">
            {connector.name}
          </h3>
        </div>
        <span className="text-sm bg-gray-100 h-8 flex justify-center items-center px-2 text-[12px] rounded-full text-gray-900">
          {connector.type}
        </span>
      </div>

      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className="w-2 h-2 bg-yellow-400 rounded-full mr-2"></div>
          <span className="text-sm text-gray-600">{connector.status}</span>
        </div>
      </div>
    </div>
  );
};
